import { WorkerAttr } from '@/types/worker-attr';

export function getLiquidTemplate(
  tag: WorkerAttr['tag'],
  id: string,
  fallback: string | undefined,
  dataType: WorkerAttr['dataType'],
) {
  const safeFallback = fallback ?? '';

  let pipes = `| default: "${safeFallback}"`;

  if (dataType === 'date') {
    pipes += ` | date: "MMMM D, YYYY"`;
  }

  return `{{ ${tag}.${id} ${pipes} }}`;
}
